


























































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { SwIconButton } from '@libs/unified-ui-framework/src/shared/sw-icon-button';
import { SwBlockingProgress } from '@libs/unified-ui-framework/src/shared/sw-blocking-progress';

import { BillMeterConfig } from './types';
import Endpoint from './assets/Icon_Endpoint_SSC_Color.svg';
import CASB from './assets/Icon_CASB_Color.svg';
import Ns from './assets/ns.svg';

import store, { RootStoreState } from '@/store';
import SwSecurityCenterInfoModal from './components/sw-security-center-info-modal.vue';
import SwSecurityCenterToggleModal from './components/sw-security-center-toggle-modal.vue';
import SwSecurityCenterToggle from './components/sw-security-center-toggle.vue';

import threats, { Threat } from './data';

const cssPrefix = 'sw-ftr-bill-meter';

@Component({
  components: {
    SwIconButton,
    SwSecurityCenterInfoModal,
    SwSecurityCenterToggleModal,
    SwSecurityCenterToggle,
    SwBlockingProgress,
  },
})
export default class SwFtrBillMeter extends Vue {

  openFullScreen () {
    const currentUrl = window.location.href;
    const win = window.open(currentUrl, '_blank');
    if (win) {
      win.focus();
    }

    // const elem = document.documentElement;
    // if (elem) {
    //   if (elem.requestFullscreen) {
    //     elem.requestFullscreen();
    //   } else if ((elem as any)['mozRequestFullScreen']) { /* Firefox */
    //     (elem as any)['mozRequestFullScreen']();
    //   } else if ((elem as any)['webkitRequestFullscreen']) { /* Chrome, Safari and Opera */
    //     (elem as any)['webkitRequestFullscreen']();
    //   } else if ((elem as any)['msRequestFullscreen']) { /* IE/Edge */
    //     (elem as any)['msRequestFullscreen']();
    //   }
    // }
  }

  closeFullScreen () {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).mozCancelFullScreen) { /* Firefox */
      (document as any).mozCancelFullScreen();
    } else if ((document as any).webkitExitFullscreen) { /* Chrome, Safari and Opera */
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) { /* IE/Edge */
      (document as any).msExitFullscreen();
    }
  }

  @State((state: RootStoreState) => (state.CoreStoreModule.selectedTenantId))
  selectedTenantId: string;

  @State((state: RootStoreState) => (state.CoreStoreModule.bmError))
  error: boolean;

  layerRotations = [0, 0, 0, 0];

  animation = 0;

  resetAllowed = false;
  @Watch('resetAllowed')
  commitResetAllowedToStore() {
    store.commit('setBmResetAllowed', { bmResetAllowed: this.resetAllowed });
  }

  @Watch('selectedTenantId')
  onSelectedTenantIdChange() {
    this.resetAllowed = false;

    window.cancelAnimationFrame(this.animation);
    this.$nextTick(() => {
      for (let i = 0; i < this.threats.length; i += 1) {
        // this.threats[i].isPenetrating = false;
        const consolidatedThreat = this.consolidatedThreats[this.threats[i].id];

        if (this.selectedTenantId in consolidatedThreat['tenants']) {
          this.threats[i].isPenetrating = false;
        } else {
          this.threats[i].isPenetrating = true;
        }
      }

      this.layerThreeInnerLayersActivated = [true, true, true];
      this.layerTwoInnerLayersActivated = [true, true];
      this.layerOneInnerLayersActivated = [true, true];
      this.layerThreeInnerLayersActivatedWhatIf = [true, true, true];
      this.layerTwoInnerLayersActivatedWhatIf = [true, true];
      this.layerOneInnerLayersActivatedWhatIf = [true, true];

      this.processThreatData();
      this.updateWalls();
      this.setThirdPartyDetails();
      // this.updateLayerPenetrating();
      this.checkIfToggleLayerIsNeeded();
      if (this.modalThreatId !== 0) {
        const threat = this.threats.find(_ => _.id === this.modalThreatId);
        if (threat) {
          this.toggleInfoModal(threat);
          if (!this.displayInfoModal) {
            this.displayInfoModal = true;
          } else if (this.displayInfoModal && this.modalIcon === threat.iconName && this.modalColor === threat.color) {
            this.displayInfoModal = false;
          }
        }
      }
      this.$nextTick(() => {
        this.start();
      });
    });
  }

  @State((state: RootStoreState) => (state.CoreStoreModule.weights))
  weights:any;

  @State((state: RootStoreState) => (state.CoreStoreModule.billmeterloading))
  loading:boolean;

  @State((state: RootStoreState) => (state.CoreStoreModule.consolidatedThreats))
  consolidatedThreats: any | undefined;

  @State((state: RootStoreState) => (state.CoreStoreModule.tenantid))
  tenantid: string | undefined;

  defcon:number = 0;

  defconCounted:number = 0;
  defconTotal:number = 0;
  defconPrecise:number = 0;
  defconColors:string[] = ['#660001', '#FD9721', '#FDCB2E', '#EDE385', '#97CC2D'];
  paragraphs: string[] = [`Malware is a classification term that define all software written with malicious
  executable code to secretly manipulate, alter, disrupt and/or damage victims’ machine.
  Most common examples of malware used to attack targeted individual or organization for social, political,
  economic and/or monetization purposes include ransomware, viruses, worms, Trojan horses, adware and spyware.`];

  displayInfoModal:boolean = false;
  modalColor:string = 'white';
  modalIcon:string = 'info';
  modalTitle:string = '';
  modalThreatId:number = 0;
  modalCount:number = -1;
  globalCount:number = -1;
  regionalCount: number = -1;
  region: string = '';
  modalSvg: boolean = false;
  modalImage: string = '';
  modalParagraphs: string[] = this.paragraphs;

  @State((state: RootStoreState) => (state.CoreStoreModule.rotations))
  rotations: number;

  @State((state: RootStoreState) => (state.CoreStoreModule.threatsWhatIf))
  threatsWhatIf: Threat[];

  @State((state: RootStoreState) => (state.CoreStoreModule.waf))
  waf: string | undefined;
  @State((state: RootStoreState) => (state.CoreStoreModule.firewall))
  firewall: string;
  @State((state: RootStoreState) => (state.CoreStoreModule.email))
  email: string | undefined;
  @State((state: RootStoreState) => (state.CoreStoreModule.cloud))
  cloud: string;
  @State((state: RootStoreState) => (state.CoreStoreModule.nextgenav))
  nextgenav: string | undefined;
  @State((state: RootStoreState) => (state.CoreStoreModule.thirdParty))
  thirdParty: any | undefined;

  cssPrefix = cssPrefix;
  billMeterConfig: BillMeterConfig = {
    elHeight: 0,
    elWidth: 0,
    exampleText: '',
  };

  fps = 10;
  scale:number = 1;

  restarted = 0;
  now:number;
  startTime:number;

  then = Date.now();
  interval = 1000 / this.fps;
  delta:number;

  isCursorOverToggle:boolean[] = [false, false, false, false];

  layersActive:boolean[] = [false, true, true, true];
  layersActiveCopy: boolean[] = this.layersActive;
  windowHeight:number = 508;
  mouseX:number = 0;
  mouseY:number = 0;

  radii:number[] = [85, 225, 425, 625];
  threats: Threat[] = threats;

  letterTitles: string[] = ['WAF', 'ATP', 'Firewall'];
  layerThreeInnerLayersActivated: boolean[] = [true, true, true];
  layerTwoInnerLayersActivated: boolean[] = [true, true];
  layerOneInnerLayersActivated: boolean[] = [true, true];
  layerThreeInnerLayersActivatedWhatIf: boolean[] = [true, true, true];
  layerTwoInnerLayersActivatedWhatIf: boolean[] = [true, true];
  layerOneInnerLayersActivatedWhatIf: boolean[] = [true, true];

  lettersHoverOver: boolean[] = [false, false, false, false];

  layerToggledRecently = 0;

  displayToggleModal1 = false;
  displayToggleModal2 = false;
  displayToggleModal3 = false;

  thirdPartyDetails: any = {};

  @Watch('displayToggleModal3')
  onDisplayToggleModal3Change() {
    if (this.displayToggleModal3) {
      this.displayToggleModal2 = false;
      this.displayToggleModal1 = false;
    }
  }

  @Watch('displayToggleModal2')
  onDisplayToggleModal2Change() {
    if (this.displayToggleModal2) {
      this.displayToggleModal3 = false;
      this.displayToggleModal1 = false;
    }
  }

  @Watch('displayToggleModal1')
  onDisplayToggleModal1Change() {
    if (this.displayToggleModal1) {
      this.displayToggleModal2 = false;
      this.displayToggleModal3 = false;
    }
  }

  hoverOverDisplayToggleModalButton1 = false;
  hoverOverDisplayToggleModalButton2 = false;
  hoverOverDisplayToggleModalButton3 = false;
  animFrameCount = 0;

  get modalHeight() {
    return this.billMeterConfig.elHeight - 30;
  }
  get modalWidth() {
    const w = this.billMeterConfig.elWidth - this.scale * (this.radii[3] + 275);
    return w > 295 ? w : 295;
  }
  get toggleModalWidth() {
    const w = this.billMeterConfig.elWidth - this.modalWidth - this.scale * (this.radii[2] + 200);
    return w > 295 ? w : 295;
  }
  get toggleModalLeft() {
    return this.billMeterConfig.elWidth - this.toggleModalWidth - this.modalWidth - 40;
  }
  @Watch('defconPrecise')
  commitDefconToStore() {
    store.commit('setDefcon', { defcon: this.defcon });
    store.commit('setDefconPrecise', { defconPrecise: this.defconPrecise });
    // this.toggleLayer();
  }

  // @Watch('threats')
  // commitThreats() {
  //   store.commit('setThreats', { threats: this.threats });
  // }

  start() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
    this.setThirdPartyDetails();
    this.drawCanvasFinal();
    const canvas = (this.$refs.canvas as HTMLCanvasElement);
    canvas.addEventListener('mousemove', this.ev_mousemove, false);
    canvas.addEventListener('click', this.ev_mouseclick, false);
    this.commitDefconToStore();
  }
  updated() {
    this.$nextTick(() => { this.setThirdPartyDetails(); });
  }
  getCurrentPath() {
    return this.$route.path.split('/')
    .slice(-1)[0];
  }
  processThreatData() {
    for (let i = 0; i < this.threats.length; i = i + 1) {
      this.threats[i].globalIndex = i;
    }
    this.threats = this.threats.filter(threat => threat.show);
  }

  updateWalls() {
    this.threats.forEach((threat) => {
      if (threat.isPenetrating) {
        if (threat.layer === 3) {
          if (typeof threat.innerLayer !== 'undefined') {
            this.layerThreeInnerLayersActivated[threat.innerLayer] = false;
          }
        } else if (threat.layer === 2) {
          if (typeof threat.innerLayer !== 'undefined') {
            this.layerTwoInnerLayersActivated[threat.innerLayer] = false;
          }
        } else if (threat.layer === 1) {
          if (typeof threat.innerLayer !== 'undefined') {
            this.layerOneInnerLayersActivated[threat.innerLayer] = false;
          }
        }
      }
    });
    this.threatsWhatIf.forEach((threat) => {
      if (threat.isPenetrating) {
        if (threat.layer === 3) {
          if (typeof threat.innerLayer !== 'undefined') {
            this.layerThreeInnerLayersActivatedWhatIf[threat.innerLayer] = false;
          }
        } else if (threat.layer === 2) {
          if (typeof threat.innerLayer !== 'undefined') {
            this.layerTwoInnerLayersActivatedWhatIf[threat.innerLayer] = false;
          }
        } else if (threat.layer === 1) {
          if (typeof threat.innerLayer !== 'undefined') {
            this.layerOneInnerLayersActivatedWhatIf[threat.innerLayer] = false;
          }
        }
      }
    });
  }

  @State((state: RootStoreState) => (state.CoreStoreModule.bmStartTime))
  bmStartTime: number;

  @Watch('loading')
  updateStartTime() {
    if (this.loading) {
      return;
    }
    if (this.bmStartTime < 0) {
      this.startTime = Date.now();
      store.commit('setBmStartTime', { bmStartTime: this.startTime });
    } else {
      this.startTime = this.bmStartTime;
    }
  }

  get showFullScreen() {
    return window.top !== window.self;
  }

  mounted () {
    if (!this.loading) {
      this.updateStartTime();
      this.then = Date.now();
    }
    this.processThreatData();

    // this.updateWalls();

    this.checkIfToggleLayerIsNeeded();
    this.start();
  }

  @Watch('layerThreeInnerLayersActivated')
  @Watch('layerTwoInnerLayersActivated')
  @Watch('layerOneInnerLayersActivated')
  @Watch('layerThreeInnerLayersActivatedWhatIf')
  @Watch('layerTwoInnerLayersActivatedWhatIf')
  @Watch('layerOneInnerLayersActivatedWhatIf')
  updateLayerOne() {
    store.commit('setToggleLayerOneActivated', { layerOneInnerLayersActivated: this.layerOneInnerLayersActivated });
    store.commit('setToggleLayerTwoActivated', { layerTwoInnerLayersActivated: this.layerTwoInnerLayersActivated });
    store.commit('setToggleLayerThreeActivated', { layerThreeInnerLayersActivated: this.layerThreeInnerLayersActivated });
    store.commit('setToggleLayerOneActivatedWhatIf', { layerOneInnerLayersActivatedWhatIf: this.layerOneInnerLayersActivatedWhatIf });
    store.commit('setToggleLayerTwoActivatedWhatIf', { layerTwoInnerLayersActivatedWhatIf: this.layerTwoInnerLayersActivatedWhatIf });
    store.commit('setToggleLayerThreeActivatedWhatIf', { layerThreeInnerLayersActivatedWhatIf: this.layerThreeInnerLayersActivatedWhatIf });
  }
  checkIfToggleLayerIsNeeded() {

    if (this.layerOneInnerLayersActivated[1]) {
      this.layerOneInnerLayersActivated[0] = true;
    }

    if ((this.thirdPartyDetails.cloud === undefined || this.thirdPartyDetails.cloud === '' || this.thirdPartyDetails.cloud === null)
     && this.layerTwoInnerLayersActivated[1]) {
      this.layerTwoInnerLayersActivated[0] = true;
    }

    // if (this.layerTwoInnerLayersActivated[1]) {
    //   this.layerTwoInnerLayersActivated[0] = true;
    // }
    let turnOffThirdLayer = true;
    let turnOnThirdLayer = false;

    for (let i = 0; i < this.layerThreeInnerLayersActivated.length; i += 1) {
      if (this.layerThreeInnerLayersActivated[i]) {
        turnOffThirdLayer = false;
        turnOnThirdLayer = true;
      }
    }

    if ((turnOffThirdLayer && this.layersActive[3]) || (turnOnThirdLayer && !this.layersActive[3])) {
      this.layerToggledRecently = 3;
      this.layersActive[3] = !this.layersActive[3];
    }

    let turnOffSecondLayer = true;
    let turnOnSecondLayer = false;

    for (let i = 0; i < this.layerTwoInnerLayersActivated.length; i += 1) {
      if (this.layerTwoInnerLayersActivated[i]) {
        turnOffSecondLayer = false;
        turnOnSecondLayer = true;
      }
    }

    if ((turnOffSecondLayer && this.layersActive[2]) || (turnOnSecondLayer && !this.layersActive[2])) {
      this.layerToggledRecently = 2;
      this.layersActive[2] = !this.layersActive[2];
    }

    let turnOffFirstLayer = true;
    let turnOnFirstLayer = false;

    for (let i = 0; i < this.layerOneInnerLayersActivated.length; i += 1) {
      if (this.layerOneInnerLayersActivated[i]) {
        turnOffFirstLayer = false;
        turnOnFirstLayer = true;
      }
    }

    if ((turnOffFirstLayer && this.layersActive[1]) || (turnOnFirstLayer && !this.layersActive[1])) {
      this.layerToggledRecently = 1;
      this.layersActive[1] = !this.layersActive[1];
    }
  }

  updateDefcon() {
    if (this.loading) {
      return;
    }
    let defconCounted = 0;
    let defconTotal = 0;
    this.threats.forEach((threat:Threat) => {
      defconTotal += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      if (!threat.isPenetrating) {
        defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      } else if (threat.innerLayer === 2 && this.thirdPartyDetails.firewall !== undefined && this.thirdPartyDetails.firewall !== null &&
       this.thirdPartyDetails.firewall !== '' && (threat.title === 'Malware' || threat.title === 'Intrusion')) {
        defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      } else if (threat.innerLayer === 0 && this.thirdPartyDetails.email !== undefined && this.thirdPartyDetails.email !== null
       && this.thirdPartyDetails.email !== '' && threat.title === 'Phishing') {
        defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      } else if (threat.innerLayer === 1 && this.thirdPartyDetails.cloud !== undefined && this.thirdPartyDetails.cloud !== null
       && this.thirdPartyDetails.cloud !== '' && threat.title === 'Cloud Data Loss') {
        defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      } else if (threat.innerLayer === 0 && this.thirdPartyDetails.nextgenav !== undefined && this.thirdPartyDetails.nextgenav !== null
       && this.thirdPartyDetails.nextgenav !== '' && (threat.title === 'Endpoint Malware' || threat.title === 'Endpoint Exploits')) {
        defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      } else if (threat.innerLayer === 0 && this.thirdPartyDetails.waf !== undefined && this.thirdPartyDetails.waf !== null
       && this.thirdPartyDetails.waf !== '') {
        defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      }
    });
    this.defconPrecise = (4 * defconCounted / defconTotal) + 1;

    this.defconCounted = defconCounted;
    this.defconTotal = defconTotal;

    if (this.defconPrecise > 4 && this.defconPrecise < 5) {
      this.defcon = 4;
    } else if (this.defconPrecise < 2 && this.defconPrecise > 1) {
      this.defcon = 2;
    } else {
      this.defcon = Math.round(this.defconPrecise);
    }
    // this.toggleLayer();
    // this.updateWalls();
    this.checkIfToggleLayerIsNeeded();
  }
  // @Watch('layersActive', { immediate: true, deep: true })
  // toggleLayer() {
  //   const i = this.layerToggledRecently;

  //   this.threats.forEach((threat:Threat) => {
  //     if (threat.layer === i) {
  //       if (!this.layersActive[i]) {
  //         threat.isPenetrating = true;
  //       } else {
  //         threat.isPenetrating = false;
  //       }
  //     }
  //   });

  //   if (i === 1 && this.layersActive[i]) {
  //     this.layerOneInnerLayersActivated = [true, true];
  //     this.layerOneInnerLayersActivatedWhatIf = [true, true];
  //   } else if (i === 1 && !this.layersActive[i]) {
  //     this.layerOneInnerLayersActivated = [false, false];
  //     this.layerOneInnerLayersActivatedWhatIf = [false, false];
  //   }

  //   if (i === 2 && this.layersActive[i]) {
  //     this.layerTwoInnerLayersActivated = [true, true];
  //     this.layerTwoInnerLayersActivatedWhatIf = [true, true];
  //   } else if (i === 2 && !this.layersActive[i]) {
  //     this.layerTwoInnerLayersActivated = [false, false];
  //     this.layerTwoInnerLayersActivatedWhatIf = [false, false];
  //   }

  //   if (i === 3 && this.layersActive[i]) {
  //     this.layerThreeInnerLayersActivated = [true, true, true];
  //     this.layerThreeInnerLayersActivatedWhatIf = [true, true, true];
  //   } else if (i === 3 && !this.layersActive[i]) {
  //     this.layerThreeInnerLayersActivated = [false, false, false];
  //     this.layerThreeInnerLayersActivatedWhatIf = [false, false, false];
  //   }
  // }
  allowReset() {
    this.resetAllowed = true;
  }
  toggleInfoModal(threat:Threat) {
    if (!this.displayInfoModal) {
      this.displayInfoModal = true;
    } else if (this.displayInfoModal && this.modalIcon === threat.iconName && this.modalColor === threat.color) {
      this.displayInfoModal = false;
    }

    const consolidatedThreat = this.consolidatedThreats[threat.id];

    this.modalColor = threat.color;
    this.modalIcon = threat.iconName;
    this.modalTitle = threat.title;
    this.modalThreatId = threat.id;

    // tslint:disable-next-line:max-line-length
    this.modalCount = consolidatedThreat['tenants'][this.selectedTenantId] !== undefined ? consolidatedThreat['tenants'][this.selectedTenantId]['count'] : -1;
    this.globalCount = consolidatedThreat['globalAverage'];
    this.regionalCount = consolidatedThreat['regionalAverage'] !== undefined ? consolidatedThreat['regionalAverage'] : -1;
    this.region = consolidatedThreat['region'] !== undefined ? consolidatedThreat['region'] : -1;

    this.modalSvg = threat.svg;
    if (threat.image) {
      this.modalImage = threat.image as string;
    }
  }

  ev_mouseclick() {
    let infoModalClose = true;
    let toggleModalClose = true;
    sessionStorage.setItem('isClickPopoverVisible', 'false');
    if (this.hoverOverDisplayToggleModalButton3) {
      this.displayToggleModal3 = !this.displayToggleModal3;
      infoModalClose = false;
      toggleModalClose = false;
    } else if (this.hoverOverDisplayToggleModalButton2) {
      this.displayToggleModal2 = !this.displayToggleModal2;
      infoModalClose = false;
      toggleModalClose = false;
    } else if (this.hoverOverDisplayToggleModalButton1) {
      this.displayToggleModal1 = !this.displayToggleModal1;
      infoModalClose = false;
      toggleModalClose = false;
    }

    // for (let i = 0; i < this.isCursorOverToggle.length; i += 1) {
    //   if (this.isCursorOverToggle[i]) {
    //     this.layerToggledRecently = i;
    //     this.layersActive[i] = !this.layersActive[i];
    //     this.allowReset();
    //     this.toggleLayer();
    //   }
    // }

    this.threats.forEach((threat:Threat) => {
      if (threat.isCursorOver) {
        this.toggleInfoModal(threat);
        infoModalClose = false;
        toggleModalClose = false;
      }
    });
    if ((infoModalClose && this.displayInfoModal) || toggleModalClose) {
      this.displayInfoModal = false;
      this.displayToggleModal1 = false;
      this.displayToggleModal2 = false;
      this.displayToggleModal3 = false;
    }

    this.checkIfToggleLayerIsNeeded();
  }
  ev_mousemove (ev:any) {
    this.mouseX = ev.offsetX;
    this.mouseY = ev.offsetY;
  }
  setCursor() {
    (this.$refs.canvas as HTMLElement).style.cursor = '';
    this.isCursorOverToggle.forEach((cursorStatus:boolean) => {
      if (cursorStatus) {
        (this.$refs.canvas as HTMLElement).style.cursor = 'pointer';
      }
    });

    this.threats.forEach((threat:Threat) => {
      if (threat.isCursorOver) {
        (this.$refs.canvas as HTMLElement).style.cursor = 'pointer';
      }
    });

    this.lettersHoverOver.forEach((isHover) => {
      if (isHover) {
        (this.$refs.canvas as HTMLElement).style.cursor = 'pointer';
      }
    });
  }
  setBackground() {
    (this.$el as HTMLElement).style.backgroundColor = 'red';
    for (let i = 0; i < this.layersActive.length; i += 1) {
      if (this.layersActive[i]) {
        (this.$el as HTMLElement).style.backgroundColor = 'black';
        break;
      }
    }
  }
  updateArrowDistances() {
    if (this.loading) {
      return;
    }
    this.now = Date.now() - this.startTime;
    this.delta = this.now - this.then;

    if (this.delta > this.interval) {
      this.threats.forEach((threat:Threat) => {
        threat.far = Math.floor(Math.random() * 2);
      });
    }
    this.then = this.now - (this.delta % this.interval);
  }
  drawEverything(ctx:any) {
    const lineWidth = 3;
    const circleFillWidth = 53;
    const N = -9 / 24;
    const M = 9 / 24;
    // const n = this.threats.filter((threat) => { return threat.show; }).length;
    const n = this.threats.length;
    const step = (M - N) / (n - 1);
    const yStep = this.windowHeight / (n - 1);
    const a = 90;
    const b = 255;

    const dashValues = [28, 13];

    for (let i = 0; i < this.threats.length; i += 1) {
      if (this.threats[i].show || true) {
        this.drawLineAndArrow(ctx, N, step, yStep, a, b, i);
      }
    }

    this.drawLayer(ctx, circleFillWidth, lineWidth, a, b, dashValues, this.radii[1], 'red', Endpoint as string, 1);
    this.drawLayer(ctx, circleFillWidth, lineWidth, a, b, dashValues, this.radii[2], '#fd9721', CASB as string, 2);
    this.drawLayer(ctx, circleFillWidth, lineWidth, a, b, dashValues, this.radii[3], '#EDE385', Ns as string, 3);
    this.drawMainCircle(ctx, lineWidth, a, b, this.radii[0], dashValues);

    // this.drawLegend(ctx);

    this.updateDefcon();
  }

  drawArrowFlatWithText(arrowX1:number, arrowY1:number, color:string, ctx:any, text:string) {
    const arrowTriangleLength = 20;
    const arrowTriangleWidth = Math.PI / 16;
    const m = 0;
    ctx.lineWidth = 3;

    const arrowTriangleX1 = arrowX1 + arrowTriangleLength * Math.cos(m + arrowTriangleWidth);
    const arrowTriangleY1 = arrowY1 + arrowTriangleLength * Math.sin(m + arrowTriangleWidth);

    const arrowTriangleX2 = arrowX1 + arrowTriangleLength * Math.cos(m - arrowTriangleWidth);
    const arrowTriangleY2 = arrowY1 + arrowTriangleLength * Math.sin(m - arrowTriangleWidth);

    ctx.beginPath();
    ctx.moveTo(arrowX1, arrowY1);
    ctx.lineTo(arrowTriangleX1, arrowTriangleY1);
    ctx.lineTo(arrowTriangleX2, arrowTriangleY2);

    ctx.fillStyle = color;
    ctx.strokeStyle = color;

    ctx.fill();

    const lineDistanceFromTriangle = arrowTriangleLength - 2;
    const arrowLength = 9;

    const arrowLineX1 = arrowX1 + lineDistanceFromTriangle * Math.cos(m);
    const arrowLineY1 = arrowY1 + lineDistanceFromTriangle * Math.sin(m);

    const arrowLineX2 = arrowLineX1 + arrowLength * Math.cos(m);
    const arrowLineY2 = arrowLineY1 + arrowLength * Math.sin(m);

    ctx.beginPath();
    ctx.moveTo(arrowLineX1, arrowLineY1);
    ctx.lineTo(arrowLineX2, arrowLineY2);
    ctx.stroke();

    ctx.beginPath();

    const fontSize = 13;
    const arrowMarginRight = 10;

    ctx.font = `${fontSize}px Nunito`;
    ctx.textBaseline = 'middle';
    ctx.fillStyle = 'white';
    ctx.fillText(text, arrowLineX2 + arrowMarginRight, arrowLineY2);
    ctx.textBaseline = 'bottom';

    const textMeasurments = ctx.measureText(text);
    return textMeasurments.width + arrowLineX2 + arrowMarginRight;
  }

  drawLegend(ctx:any) {
    const windowHeight = 508;

    const legendMargin = 10;
    const legendHeight = 20;

    const legendX = legendMargin;
    const legendY = windowHeight - legendMargin;
    const legendPadding = 10;

    ctx.fillStyle = '#FF791A';
    ctx.strokeStyle = '#47AFE8';

    const secondArrowX = this.drawArrowFlatWithText(legendX + legendPadding, legendY - legendHeight / 2, '#ff791a', ctx, 'Tenant Data');
    this.drawArrowFlatWithText(secondArrowX + 20, legendY - legendHeight / 2, '#47AFE8', ctx, 'Global Averages');
  }

  midpointBezierCurve(x1:number, y1:number, x2:number, y2:number, xDiff:number, yDiff:number, ctx:any) {
    const spread = 49 / 100;
    ctx.bezierCurveTo(x1 + (x2 - x1) * spread + xDiff, y1 + (y2 - y1) * spread + yDiff,
                      x1 + (x2 - x1) * (1 - spread) + xDiff, y1 + (y2 - y1) * (1 - spread) + yDiff,
                      x2, y2);
  }

  prepareCanvas(ctx:any) {
    ctx.clearRect(0, 0, 300, 150);
    ctx.canvas.width  = this.billMeterConfig.elWidth;
    ctx.canvas.height  = this.billMeterConfig.elHeight;

    this.scale = ctx.canvas.height / this.windowHeight;
    ctx.scale(this.scale, this.scale);
  }
  drawCanvasFinal () {
    this.animation = requestAnimationFrame(this.drawCanvasFinal);

    if (this.now > 180000) {
      this.startTime = Date.now();
      store.commit('setBmStartTime', { bmStartTime: this.startTime });
      this.restarted += 1;
    }

    this.updateArrowDistances();
    const canvas = (this.$refs.canvas as HTMLCanvasElement);
    if (!canvas) {
      return;
    }
    const ctx = canvas.getContext('2d');
    if (ctx) {
      this.prepareCanvas(ctx);
      this.drawEverything(ctx);
      this.setCursor();
      this.setBackground();
    }
  }
  drawLine(ctx:any, x1:number, y1:number, x2:number, y2:number) {
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.lineWidth = 3;
    if (this.defcon === 1) {
      ctx.strokeStyle = 'rgba(48, 48, 48, 0.3)';
    } else {
      ctx.strokeStyle = 'rgba(48, 48, 48, 0.8)';
    }

    ctx.setLineDash([]);
    ctx.stroke();
  }
  extendLine(ctx:any, x2:number, y2:number, m:number) {
    ctx.beginPath();
    ctx.moveTo(x2, y2);
    ctx.lineTo(x2 + 1000 * Math.cos(m), y2 + 1000 * Math.sin(m));
    ctx.stroke();
  }
  /* SPLIT THIS */
  drawLineAndArrow (ctx:any, N:number, step:number, yStep:number, a:number, b:number, i:number) {
    const theta = (N + step * i) * Math.PI;

    const x1 = a + this.radii[0] * Math.cos(theta);
    const y1 = b + this.radii[0] * Math.sin(theta);

    const x2 = 1000;
    const y2 = yStep * i;

    this.drawLine(ctx, x1, y1, x2, y2);

    const m = (y1 - y2) / (x1 - x2); // slope

    this.extendLine(ctx, x2, y2, m);

    const z = y1 - m * x1; // y intercept
    if (!this.loading) {
      const consolidatedThreat = this.consolidatedThreats[this.threats[i].id];
      this.drawArrow(ctx, i, m, a, b, z, consolidatedThreat);
    }
  }
  updateLayerPenetrating() {
    for (let i = 0; i < this.threats.length; i += 1) {
      if (this.threats[i].show) {
        const threat = this.threats[i];
        if (threat.layer === 3) {
          if (threat.innerLayer !== undefined && this.layerThreeInnerLayersActivated[threat.innerLayer]) {
            if (this.layerThreeInnerLayersActivated[threat.innerLayer]) {
              this.threats[i].isPenetrating = false;
            }
            if (threat.innerLayer === 0 && this.thirdPartyDetails.waf !== undefined && this.thirdPartyDetails.waf !== null
             && this.thirdPartyDetails.waf !== '') {
              this.threats[i].isPenetrating = false;
            } else if (threat.innerLayer === 2 && this.thirdPartyDetails.firewall !== undefined && this.thirdPartyDetails.firewall !== null
             && this.thirdPartyDetails.firewall !== '' && (threat.title ===
             'Malware'
             || threat.title === 'Intrusion')) {
              this.threats[i].isPenetrating = false;
            } else {
              this.threats[i].isPenetrating = true;
            }
          } else {
            if (threat.innerLayer === 0 && this.thirdPartyDetails.waf !== undefined && this.thirdPartyDetails.waf !== null
             && this.thirdPartyDetails.waf !== '') {
              this.threats[i].isPenetrating = false;
            } else if (threat.innerLayer === 2 && this.thirdPartyDetails.firewall !== undefined && this.thirdPartyDetails.firewall !== null
             && this.thirdPartyDetails.firewall !== '' && (threat.title ===
             'Malware'
             || threat.title === 'Intrusion')) {
              this.threats[i].isPenetrating = false;
            } else {
              this.threats[i].isPenetrating = true;
            }
          }
        } else if (threat.layer === 2) {
          if (threat.innerLayer !== undefined && this.layerTwoInnerLayersActivated[threat.innerLayer]) {
            if (this.layerTwoInnerLayersActivated[threat.innerLayer]) {
              this.threats[i].isPenetrating = false;
            }
            if (threat.innerLayer === 0 && this.thirdPartyDetails.email !== undefined && this.thirdPartyDetails.email !== null
             && this.thirdPartyDetails.email !== '' && threat.title === 'Phishing') {
              this.threats[i].isPenetrating = false;
            } else if (threat.innerLayer === 1 && this.thirdPartyDetails.cloud !== undefined && this.thirdPartyDetails.cloud !== null
             && this.thirdPartyDetails.cloud !== '' && threat.title === 'Cloud Data Loss') {
              this.threats[i].isPenetrating = false;
            } else {
              this.threats[i].isPenetrating = true;
            }
          } else {
            if (threat.innerLayer === 0 && this.thirdPartyDetails.email !== undefined && this.thirdPartyDetails.email !== null
             && this.thirdPartyDetails.email !== '' && threat.title === 'Phishing') {
              this.threats[i].isPenetrating = false;
            } else if (threat.innerLayer === 1 && this.thirdPartyDetails.cloud !== undefined && this.thirdPartyDetails.cloud !== null
             && this.thirdPartyDetails.cloud !== '' && threat.title === 'Cloud Data Loss') {
              this.threats[i].isPenetrating = false;
            } else {
              this.threats[i].isPenetrating = true;
            }
          }
        } else if (threat.layer === 1) {
          if (threat.innerLayer !== undefined && this.layerOneInnerLayersActivated[threat.innerLayer]) {
            if (this.layerOneInnerLayersActivated[threat.innerLayer]) {
              this.threats[i].isPenetrating = false;
            }
            if (threat.innerLayer === 0 && this.thirdPartyDetails.nextgenav !== undefined && this.thirdPartyDetails.nextgenav !== null
             && this.thirdPartyDetails.nextgenav !== '' && (threat.title === 'Endpoint Malware' ||
              threat.title === 'Endpoint Exploits')) {
              this.threats[i].isPenetrating = false;
            } else {
              this.threats[i].isPenetrating = true;
            }
          } else {
            if (threat.innerLayer === 0 && this.thirdPartyDetails.nextgenav !== undefined && this.thirdPartyDetails.nextgenav !== null
             && this.thirdPartyDetails.nextgenav !== '' && (threat.title === 'Endpoint Malware' ||
              threat.title === 'Endpoint Exploits')) {
              this.threats[i].isPenetrating = false;
            } else {
              this.threats[i].isPenetrating = true;
            }
          }
        }
      }
    }
  }
  drawArrow(ctx:any, i:number, m:number, a:number, b:number, z:number, consolidatedThreat:any) {
    const threat = this.threats[i];
    let r;

    for (let i = 0; i < this.threats.length; i += 1) {
      // this.threats[i].isPenetrating = false;
      const consolidatedThreat = this.consolidatedThreats[this.threats[i].id];

      if (this.selectedTenantId in consolidatedThreat['tenants']) {
        this.threats[i].isPenetrating = false;
      } else {
        this.threats[i].isPenetrating = true;
      }
    }
    if (threat.layer === 3) {
      if (threat.innerLayer !== undefined && this.layerThreeInnerLayersActivated[threat.innerLayer]) {
        // r = this.radii[threat.layer] + 25;
        if (threat.innerLayer === 0 && this.thirdPartyDetails.waf !== undefined && this.thirdPartyDetails.waf !== null && this.thirdPartyDetails.waf !== '') {
          threat.isPenetrating = false;
          r = this.radii[threat.layer] + 25;
        } else if (threat.innerLayer === 2 && this.thirdPartyDetails.firewall !== undefined && this.thirdPartyDetails.firewall !== null
          && this.thirdPartyDetails.firewall !== '' &&
         (threat.title === 'Malware' || threat.title === 'Intrusion')) {
          threat.isPenetrating = false;
          r = this.radii[threat.layer] + 25;
        } else if (this.layerThreeInnerLayersActivated[threat.innerLayer]) {
          threat.isPenetrating = false;
          r = this.radii[threat.layer] + 25;
        } else {
          threat.isPenetrating = true;
          r = this.radii[0];
        }
      } else {
        // r = this.radii[0];
        if (threat.innerLayer === 0 && this.thirdPartyDetails.waf !== undefined && this.thirdPartyDetails.waf !== null && this.thirdPartyDetails.waf !== '') {
          threat.isPenetrating = false;
          r = this.radii[threat.layer] + 25;
        } else if (threat.innerLayer === 2 && this.thirdPartyDetails.firewall !== undefined && this.thirdPartyDetails.firewall !== null
          && this.thirdPartyDetails.firewall !== '' &&
         (threat.title === 'Malware' || threat.title === 'Intrusion')) {
          threat.isPenetrating = false;
          r = this.radii[threat.layer] + 25;
        } else {
          threat.isPenetrating = true;
          r = this.radii[0];
        }
      }
    } else if (threat.layer === 2) {
      if (threat.innerLayer !== undefined && this.layerTwoInnerLayersActivated[threat.innerLayer]) {
        if (threat.innerLayer === 0 && this.thirdPartyDetails.email !== undefined && this.thirdPartyDetails.email !== null
         && this.thirdPartyDetails.email !== '') {
          if (threat.title === 'Phishing') {
            threat.isPenetrating = false;
            r = this.radii[threat.layer] + 25;
          } else {
            threat.isPenetrating = true;
            r = this.radii[0];
          }
        } else if (threat.innerLayer === 1 && this.thirdPartyDetails.cloud !== undefined && this.thirdPartyDetails.cloud !== null
         && this.thirdPartyDetails.cloud !== '') {
          if (threat.title === 'Cloud Data Loss') {
            threat.isPenetrating = false;
            r = this.radii[threat.layer] + 25;
          } else {
            threat.isPenetrating = true;
            r = this.radii[0];
          }
        } else if (this.layerTwoInnerLayersActivated[threat.innerLayer]) {
          threat.isPenetrating = false;
          r = this.radii[threat.layer] + 25;
        } else {
          threat.isPenetrating = true;
          r = this.radii[0];
        }
      } else {
        // r = this.radii[0];
        if (threat.innerLayer === 0 && this.thirdPartyDetails.email !== undefined && this.thirdPartyDetails.email !== null
         && this.thirdPartyDetails.email !== '' && threat.title === 'Phishing') {
          threat.isPenetrating = false;
          r = this.radii[threat.layer] + 25;
        } else if (threat.innerLayer === 1 && this.thirdPartyDetails.cloud !== undefined && this.thirdPartyDetails.cloud !== null
         && this.thirdPartyDetails.cloud !== '' && threat.title === 'Cloud Data Loss') {
          threat.isPenetrating = false;
          r = this.radii[threat.layer] + 25;
        } else {
          threat.isPenetrating = true;
          r = this.radii[0];
        }
      }
    } else if (threat.layer === 1) {
      if (threat.innerLayer !== undefined && this.layerOneInnerLayersActivated[threat.innerLayer]) {
        // r = this.radii[threat.layer] + 25;
        if (threat.innerLayer === 0 && this.thirdPartyDetails.nextgenav !== undefined && this.thirdPartyDetails.nextgenav !== null
         && this.thirdPartyDetails.nextgenav !== '' && (threat.title === 'Endpoint Malware' ||
          threat.title === 'Endpoint Exploits')) {
          threat.isPenetrating = false;
          r = this.radii[threat.layer] + 25;
        } if (this.layerOneInnerLayersActivated[threat.innerLayer]) {
          threat.isPenetrating = false;
          r = this.radii[threat.layer] + 25;
        } else {
          threat.isPenetrating = true;
          r = this.radii[0];
        }
      } else {
        // r = this.radii[0];
        if (threat.innerLayer === 0 && this.thirdPartyDetails.nextgenav !== undefined && this.thirdPartyDetails.nextgenav !== null
         && this.thirdPartyDetails.nextgenav !== '' && (threat.title === 'Endpoint Malware' ||
          threat.title === 'Endpoint Exploits')) {
          threat.isPenetrating = false;
          r = this.radii[threat.layer] + 25;
        } else {
          threat.isPenetrating = true;
          r = this.radii[0];
        }
      }
    } else {
      r = this.radii[0];
    }

    // for (let i = 0; i < this.threats.length; i += 1) {
    //   // this.threats[i].isPenetrating = false;
    //   const consolidatedThreat = this.consolidatedThreats[this.threats[i].id];

    //   if (this.selectedTenantId in consolidatedThreat['tenants']) {
    //     this.threats[i].isPenetrating = false;
    //   } else {
    //     this.threats[i].isPenetrating = true;
    //   }
    // }

    let quadraticA = m * m + 1;
    let quadraticB = (2 * m) * (z - b) - 2 * a;
    let quadraticC = a * a + (z - b) * (z - b) - r * r;

    const arrowX0 = quadraticFormula(quadraticA, quadraticB, quadraticC);
    const arrowY0 = arrowX0 * m + z;

    const arrowDistanceFromCircle = threat.far * 10;

    const arrowX1 = arrowX0 + arrowDistanceFromCircle * Math.cos(m);
    const arrowY1 = arrowY0 + arrowDistanceFromCircle * Math.sin(m);

    const arrowTriangleLength = 20;
    const arrowTriangleWidth = Math.PI / 16;

    const arrowTriangleX1 = arrowX1 + arrowTriangleLength * Math.cos(m + arrowTriangleWidth);
    const arrowTriangleY1 = arrowY1 + arrowTriangleLength * Math.sin(m + arrowTriangleWidth);

    const arrowTriangleX2 = arrowX1 + arrowTriangleLength * Math.cos(m - arrowTriangleWidth);
    const arrowTriangleY2 = arrowY1 + arrowTriangleLength * Math.sin(m - arrowTriangleWidth);

    ctx.beginPath();
    ctx.moveTo(arrowX1, arrowY1);
    ctx.lineTo(arrowTriangleX1, arrowTriangleY1);
    ctx.lineTo(arrowTriangleX2, arrowTriangleY2);

    if (this.selectedTenantId in consolidatedThreat['tenants']) {
      if (consolidatedThreat['tenants'][this.selectedTenantId]['count'] === -1) {
        ctx.fillStyle = '#47AFE8';
        ctx.strokeStyle = '#47AFE8';
      } else {
        ctx.fillStyle = '#FF791A';
        ctx.strokeStyle = '#FF791A';
      }
    } else {
      ctx.fillStyle = '#47AFE8';
      ctx.strokeStyle = '#47AFE8';
    }

    ctx.fill();

    const lineDistanceFromTriangle = arrowTriangleLength - 2;
    const arrowLength = 9;

    const arrowLineX1 = arrowX1 + lineDistanceFromTriangle * Math.cos(m);
    const arrowLineY1 = arrowY1 + lineDistanceFromTriangle * Math.sin(m);

    const arrowLineX2 = arrowLineX1 + arrowLength * Math.cos(m);
    const arrowLineY2 = arrowLineY1 + arrowLength * Math.sin(m);

    ctx.beginPath();
    ctx.moveTo(arrowLineX1, arrowLineY1);
    ctx.lineTo(arrowLineX2, arrowLineY2);
    ctx.stroke();

    // r = this.radii[threat.layer] + 65; SAIF
    r = r + 45;

    quadraticA = m * m + 1;
    quadraticB = (2 * m) * (z - b) - 2 * a;
    quadraticC = a * a + (z - b) * (z - b) - r * r;

    const logoX = quadraticFormula(quadraticA, quadraticB, quadraticC);
    const logoY =  logoX * m + z;

    ctx.save();
    ctx.translate(logoX, logoY);
    ctx.rotate(m);

    if (threat.svg && threat.image) {
      const threatImg = new Image();
      threatImg.src = threat.image as string;
      threatImg.style.fill = 'red';
      const threatHeight = 14;
      const threatWidth = threatHeight * threatImg.width / threatImg.height;
      ctx.drawImage(threatImg, 0, -7, threatHeight, threatWidth);
    } else {
      ctx.beginPath();
      ctx.fillStyle = threat.color;
      ctx.font = '14px SonicWallIconFont';
      ctx.fillText(threat.icon, 0, 5);
    }

    ctx.beginPath();
    ctx.moveTo(0, -7);
    ctx.lineTo(0, 7);
    ctx.lineTo(14, 7);
    ctx.lineTo(14, -7);
    ctx.lineTo(0, -7);

    if (ctx.isPointInPath(this.mouseX, this.mouseY)) {
      this.threats[i].isCursorOver = true;
    } else {
      this.threats[i].isCursorOver = false;
    }

    ctx.restore();
  }
  drawMainCircle (ctx:any, lineWidth:number, a:number, b:number, r:number, dashValues:number[]) {
    const mainCircleColor = this.defconColors[this.defcon - 1];
    ctx.beginPath();
    ctx.fillStyle = mainCircleColor;
    ctx.font = '75px SonicWallIconFont';
    ctx.fillText('\uf1f9', 52, 285);

    const i = 0;
    const rot = this.rotations;

    let circleThetaStartUnadjusted = ((this.now / 500) * (i % 2 === 1 ? 1 : -1));
    circleThetaStartUnadjusted = Math.abs(circleThetaStartUnadjusted / rot) < Math.PI ?
    rot - Math.cos(circleThetaStartUnadjusted / (rot)) * (rot) + this.restarted * 2 * rot : (2 * rot * (this.restarted + 1));
    circleThetaStartUnadjusted *= (i % 2 === 1 ? 1 : -1);

    const circleThetaStart =  circleThetaStartUnadjusted * 125 / r;
    const circleThetaEnd = 2 * Math.PI + circleThetaStart;

    ctx.beginPath();
    ctx.lineWidth = lineWidth;
    ctx.strokeStyle = mainCircleColor;
    ctx.setLineDash(dashValues);
    ctx.arc(a, b, r, circleThetaStart, circleThetaEnd);
    ctx.stroke();

    ctx.beginPath();
    const theta = (this.now / 500) % (2 * Math.PI);

    ctx.arc(
      a + r * Math.cos(theta),
      b + r * Math.sin(theta),
      4, 0, (2 * Math.PI),
    );
    ctx.setLineDash([]);
    ctx.strokeStyle = 'cyan';
    ctx.fillStyle = 'cyan';

    ctx.closePath();

    ctx.stroke();
    ctx.fill();
  }
  /* SPLIT THIS */
  drawLayer (ctx:any, circleFillWidth:any,
             lineWidth:any, a:number, b:number, dashValues:any, r:number, color:string, imgSrc:string, i:number) {
    ctx.beginPath();
    ctx.lineWidth = circleFillWidth;
    if (this.layersActive[i]) {
      ctx.strokeStyle = 'rgba(0,0,0,0.5)';
    } else {
      ctx.strokeStyle = 'rgba(0,0,0,0.25)';
    }
    ctx.setLineDash([]);

    const rot = this.rotations;

    let circleThetaStartUnadjusted = ((this.now / 500) * (i % 2 === 1 ? 1 : -1));
    circleThetaStartUnadjusted = Math.abs(circleThetaStartUnadjusted / rot) < Math.PI ?
    rot - Math.cos(circleThetaStartUnadjusted / (rot)) * (rot) + this.restarted * 2 * rot : (2 * rot * (this.restarted + 1));
    circleThetaStartUnadjusted *= (i % 2 === 1 ? 1 : -1);

    const circleThetaStart =  this.layersActive[i] ? circleThetaStartUnadjusted * 150 / r : 0;
    const circleThetaEnd = 2 * Math.PI + circleThetaStart;

    Vue.set(this.layerRotations, i, circleThetaStartUnadjusted);

    ctx.arc(a, b, r, circleThetaStart, circleThetaEnd);
    ctx.stroke();

    if (this.layersActive[i]) {
      ctx.strokeStyle = color;
    } else {
      if (this.defcon === 1) {
        ctx.strokeStyle = 'black';
      } else {
        ctx.strokeStyle = 'rgba(48, 48, 48, 0.8)';
      }
    }

    ctx.beginPath();
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(dashValues);
    ctx.arc(a, b, r - 25, circleThetaStart, circleThetaEnd);
    ctx.stroke();

    ctx.beginPath();
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(dashValues);
    ctx.arc(a, b, r + 25, circleThetaStart, circleThetaEnd);
    ctx.stroke();

    const imageCircleA = a + r - 25;
    const imageCircleB = b;
    const imageCircleR = 36;

    if (this.layersActive[i]) {
      for (let j = 0; j < 3; j += 1) {
        const crazyCircleRMax = 30;
        const now = this.now / 70 + j / 3 * crazyCircleRMax + i / 3 * crazyCircleRMax;

        ctx.beginPath();
        ctx.lineWidth = 4;
        ctx.setLineDash([]);

        const crazyCircleR = now % crazyCircleRMax + imageCircleR;

        ctx.lineWidth = 1;
        ctx.globalAlpha = 1 - now % crazyCircleRMax / (crazyCircleRMax + 1);
        ctx.arc(imageCircleA, imageCircleB, crazyCircleR, 0, 2 * Math.PI);

        ctx.strokeStyle = '#FF791A';
        ctx.stroke();
        ctx.globalAlpha = 1;
      }
    }

    ctx.beginPath();
    ctx.lineWidth = 4;
    ctx.setLineDash([]);
    ctx.arc(imageCircleA, imageCircleB, imageCircleR, 0, 2 * Math.PI);
    if (this.layersActive[i] || this.defcon === 1) {
      ctx.fillStyle = 'black';
      ctx.strokeStyle = '#FF791A';
    } else {
      ctx.lineWidth = ctx.lineWidth / 2;
      ctx.fillStyle = 'rgba(0, 0, 0, 0.25)';
      ctx.strokeStyle = 'rgba(255, 121, 26, 0.25)';
    }
    ctx.stroke();
    ctx.fill();

    if (i === 3) {
      if (ctx.isPointInPath(this.mouseX, this.mouseY)) {
        this.hoverOverDisplayToggleModalButton3 = true;
      } else {
        this.hoverOverDisplayToggleModalButton3 = false;
      }
    }

    if (i === 2) {
      if (ctx.isPointInPath(this.mouseX, this.mouseY)) {
        this.hoverOverDisplayToggleModalButton2 = true;
      } else {
        this.hoverOverDisplayToggleModalButton2 = false;
      }
    }

    if (i === 1) {
      if (ctx.isPointInPath(this.mouseX, this.mouseY)) {
        this.hoverOverDisplayToggleModalButton1 = true;
      } else {
        this.hoverOverDisplayToggleModalButton1 = false;
      }
    }

    ctx.beginPath();
    const img = new Image();
    img.src = imgSrc;

    this.$nextTick(() => {
      const imgHeight = 45;
      const imgWidth = imgHeight * img.width / img.height;
      if (!this.layersActive[i] && this.defcon !== 1) {
        ctx.globalAlpha = 0.5;
      }
      ctx.drawImage(img, imageCircleA - imgWidth / 2, imageCircleB - imgHeight / 2, imgWidth, imgHeight);
      ctx.globalAlpha = 1.0;
    });

    const toggleTheta = Math.asin(this.windowHeight / 2 / r);
    let toggleX = a + (r + 12.5) * Math.cos(toggleTheta);
    if (isNaN(toggleX)) {
      toggleX = a;
    } else if (i === 2) {
      toggleX = a + (r + 25) * Math.cos(toggleTheta);
    }

    // const toggleLineHeight = circleFillWidth - 17;
    // const toggleLineWidth = 7;

    // const toggleLineY = 12.5;
    // const toggleLineX = toggleX - toggleLineWidth / 2;
    // const toggleLineCurve = 2;

    // if (this.layersActive[i]) {
    //   ctx.fillStyle = '#000000';
    // } else {
    //   ctx.fillStyle = '#000000';
    // }

    // this.isCursorOverToggle[i] = false;

    // ctx.beginPath();
    // ctx.moveTo(toggleLineX, toggleLineY);
    // ctx.lineTo(toggleLineX, toggleLineY + toggleLineHeight);
    // ctx.bezierCurveTo(toggleLineWidth / 3 + toggleLineX,
    //                   toggleLineY + toggleLineHeight + toggleLineCurve,
    //                   2 * toggleLineWidth / 3 + toggleLineX,
    //                   toggleLineY + toggleLineHeight + toggleLineCurve,
    //                   toggleLineX + toggleLineWidth,
    //                   toggleLineY + toggleLineHeight);
    // ctx.lineTo(toggleLineX + toggleLineWidth, toggleLineY);
    // ctx.bezierCurveTo(2 * toggleLineWidth / 3 + toggleLineX,
    //                   toggleLineY - toggleLineCurve,
    //                   toggleLineWidth / 3 + toggleLineX,
    //                   toggleLineY - toggleLineCurve,
    //                   toggleLineX,
    //                   toggleLineY);
    // ctx.fill();

    // if (ctx.isPointInPath(this.mouseX, this.mouseY)) {
    //   this.isCursorOverToggle[i] = false;
    // }

    // ctx.beginPath();
    // ctx.moveTo(toggleLineX - 10, toggleLineY - 10);
    // ctx.lineTo(toggleLineX - 10, toggleLineY + toggleLineHeight + 10);
    // ctx.bezierCurveTo(toggleLineWidth / 3 + toggleLineX,
    //                   toggleLineY + toggleLineHeight + toggleLineCurve,
    //                   2 * toggleLineWidth / 3 + toggleLineX,
    //                   toggleLineY + toggleLineHeight + toggleLineCurve,
    //                   toggleLineX + toggleLineWidth + 10,
    //                   toggleLineY + toggleLineHeight + 10);
    // ctx.lineTo(toggleLineX + toggleLineWidth + 10, toggleLineY - 10);
    // ctx.bezierCurveTo(2 * toggleLineWidth / 3 + toggleLineX,
    //                   toggleLineY - toggleLineCurve,
    //                   toggleLineWidth / 3 + toggleLineX,
    //                   toggleLineY - toggleLineCurve,
    //                   toggleLineX - 10,
    //                   toggleLineY - 10);

    // if (ctx.isPointInPath(this.mouseX, this.mouseY)) {
    //   this.isCursorOverToggle[i] = false;
    // }

    // const toggleBallX = toggleX;
    // const toggleBallOffset = 12;
    // let toggleBallY;

    // if (this.layersActive[i]) {
    //   toggleBallY = toggleLineY + toggleBallOffset;
    // } else {
    //   toggleBallY = toggleLineY + toggleLineHeight - toggleBallOffset;
    // }

    // ctx.beginPath();
    // ctx.arc(toggleBallX, toggleBallY, 10, 0, 2 * Math.PI);
    // ctx.fill();

    // ctx.lineWidth = lineWidth;
    // ctx.strokeStyle = this.defcon !== 1 ? 'black' : '#BF0000';
    // ctx.closePath();
    // ctx.stroke();

    // if (ctx.isPointInPath(this.mouseX, this.mouseY)) {
    //   this.isCursorOverToggle[i] = false;
    // }
  }
  onResize () {
    this.billMeterConfig.elHeight = this.$el.clientHeight;
    this.billMeterConfig.elWidth = this.$el.clientWidth;
  }

  @Watch('thirdParty')
  setThirdPartyDetails() {
    if (Object.keys(this.thirdParty).length > 0) {
      this.thirdPartyDetails = this.thirdParty.filter((item: any) => {
        return item.id === this.selectedTenantId;
      })[0];
      if (this.thirdPartyDetails) {
        if (this.thirdPartyDetails.waf !== undefined && this.thirdPartyDetails.waf !== null && this.thirdPartyDetails.waf !== '') {
          this.layerThreeInnerLayersActivated[0] = true;
        } else if (this.thirdPartyDetails.waf === null || this.thirdPartyDetails.waf === '') {
          for (let i = 0; i < this.threats.length; i += 1) {
            // this.threats[i].isPenetrating = false;
            const consolidatedThreat = this.consolidatedThreats[this.threats[i].id];

            if (this.selectedTenantId in consolidatedThreat['tenants']) {
              this.layerThreeInnerLayersActivated[0] = true;
            } else {
              this.layerThreeInnerLayersActivated[0] = false;
            }
          }
          // this.layerThreeInnerLayersActivated[0] = false;
        }
        if (this.thirdPartyDetails.firewall !== undefined && this.thirdPartyDetails.firewall !== null && this.thirdPartyDetails.firewall !== '') {
          this.layerThreeInnerLayersActivated[2] = true;
        } else if (this.thirdPartyDetails.firewall === null || this.thirdPartyDetails.firewall === '') {
          for (let i = 0; i < this.threats.length; i += 1) {
            // this.threats[i].isPenetrating = false;
            const consolidatedThreat = this.consolidatedThreats[this.threats[i].id];

            if (this.selectedTenantId in consolidatedThreat['tenants']) {
              this.layerThreeInnerLayersActivated[0] = true;
            } else {
              this.layerThreeInnerLayersActivated[0] = false;
            }
          }
          // this.layerThreeInnerLayersActivated[2] = false;
        }
        if (this.thirdPartyDetails.nextgenav !== undefined && this.thirdPartyDetails.nextgenav !== null && this.thirdPartyDetails.nextgenav !== '') {
          this.layerOneInnerLayersActivated[0] = true;
        } else if (this.thirdPartyDetails.nextgenav === null || this.thirdPartyDetails.nextgenav === '') {
          for (let i = 0; i < this.threats.length; i += 1) {
            // this.threats[i].isPenetrating = false;
            const consolidatedThreat = this.consolidatedThreats[this.threats[i].id];

            if (this.selectedTenantId in consolidatedThreat['tenants']) {
              this.layerOneInnerLayersActivated[0] = true;
            } else {
              this.layerOneInnerLayersActivated[0] = false;
            }
          }
          // this.layerOneInnerLayersActivated[0] = false;
        }
        if (this.thirdPartyDetails.cloud !== undefined && this.thirdPartyDetails.cloud !== null && this.thirdPartyDetails.cloud !== '') {
          this.layerTwoInnerLayersActivated[1] = true;
        } else if (this.thirdPartyDetails.cloud === null || this.thirdPartyDetails.cloud === '') {
          for (let i = 0; i < this.threats.length; i += 1) {
            // this.threats[i].isPenetrating = false;
            const consolidatedThreat = this.consolidatedThreats[this.threats[i].id];

            if (this.selectedTenantId in consolidatedThreat['tenants']) {
              this.layerTwoInnerLayersActivated[0] = true;
            } else {
              this.layerTwoInnerLayersActivated[0] = false;
            }
          }
          // this.layerTwoInnerLayersActivated[1] = false;
        }
        if (this.thirdPartyDetails.email !== undefined && this.thirdPartyDetails.email !== null && this.thirdPartyDetails.email !== '') {
          this.layerTwoInnerLayersActivated[0] = true;
        } else if (this.thirdPartyDetails.email === null || this.thirdPartyDetails.email === '') {
          for (let i = 0; i < this.threats.length; i += 1) {
            // this.threats[i].isPenetrating = false;
            const consolidatedThreat = this.consolidatedThreats[this.threats[i].id];

            if (this.selectedTenantId in consolidatedThreat['tenants']) {
              this.layerTwoInnerLayersActivated[0] = true;
            } else {
              this.layerTwoInnerLayersActivated[0] = false;
            }
          }
          // this.layerTwoInnerLayersActivated[0] = false;
        }
        // this.updateLayerPenetrating();
      }
    }
    // this.updateLayerPenetrating();
  }
}

/*
  utility function for quadratic formula. Used for calculating
  intersection beetween lines and circles
*/
function quadraticFormula(a:number , b:number , c:number) {
  const result = (-1 * b + Math.sqrt(Math.pow(b, 2) - (4 * a * c))) / (2 * a);
  const result2 = (-1 * b - Math.sqrt(Math.pow(b, 2) - (4 * a * c))) / (2 * a);
  return result > 0 ? result : result2;
}
